import React from 'react';

import { FooterWrapper } from './Layout.style';
import logoSmall from '../assets/images/logo/logo-mobile.svg';

const Footer = () => {
  return (
    <FooterWrapper>
      <ul>
        <li>&copy; 2022 MDPortals Inc.</li>
        <li>
          <img src={logoSmall} alt="Reveleer Logo" width="30" height="30" />
        </li>
      </ul>
    </FooterWrapper>
  );
};

export default Footer;
